module.exports = __webpack_public_path__ + "img/kisses.39803030.gif";